<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <p-tabMenu
    styleClass="mb-3"
    [model]="tabItems"
    (activeItemChange)="onTabChange($event)">
  </p-tabMenu>
  <ng-container *ngIf="selectedTab === 'general'">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Name'"
        [name]="'name'"
        [formField]="form.get('name')"
        [colSize]="8">
        <input
          pInputText
          id="name"
          type="text"
          formControlName="name"
          class="p-input" />
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'Schlüssel'"
        [name]="'key'"
        [colSize]="4"
        [formField]="form.get('key')">
        <input
          pInputText
          id="key"
          type="text"
          formControlName="key"
          class="p-input" />
      </app-form-field-wrapper>

      <app-form-field-wrapper
        *ngIf="!isChild"
        [label]="'Ordner'"
        [name]="'category'"
        [formField]="form.get('category')"
        [colSize]="6">
        <p-treeSelect
          *ngIf="categoryStore.asTree() as categories"
          containerStyleClass="w-full"
          formControlName="category"
          [filter]="true"
          [options]="categories">
        </p-treeSelect>
      </app-form-field-wrapper>
      <app-tag-dropdown
        mode="all"
        [colSize]="6"
        formControlName="tags"></app-tag-dropdown>
    </div>
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Einheit'"
        [name]="'unit'"
        [colSize]="4"
        *ngIf="!isChild">
        <p-dropdown
          id="unit"
          formControlName="unit"
          [options]="units"
          optionLabel="name"
          optionValue="key"
          dataKey="key"></p-dropdown>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [colSize]="4"
        [label]="'Dezimalstellen'"
        [name]="'decimals'">
        <p-inputNumber
          formControlName="decimals"
          inputId="decimals"
          mode="decimal"
          [min]="0"
          [max]="10">
        </p-inputNumber>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [colSize]="4"
        [label]="'Gesperrt'"
        [name]="'locked'"
        [floatingLabel]="true">
        <p-inputSwitch id="locked" formControlName="locked"></p-inputSwitch>
      </app-form-field-wrapper>
    </div>
  </ng-container>
  <div *ngIf="selectedTab === 'indicator-set'">
    @if (childrenUpdated) {
      <app-alert>
        Um die Anpassungen an den Ausprägungen zu speichern, speichern Sie bitte
        den Indikator!
      </app-alert>
    }
    <app-form-field-wrapper
      [label]="'Indikator mit mehreren Ausprägungen'"
      [name]="'isSet'"
      [floatingLabel]="false"
      [hideLabel]="true">
      <p-checkbox
        inputId="isSet"
        formControlName="isSet"
        [binary]="true"
        label="Indikator mit mehreren Ausprägungen"></p-checkbox>
    </app-form-field-wrapper>

    <div
      formArrayName="children"
      cdkDropList
      (cdkDropListDropped)="drop($event)">
      <div
        class="grid drag-item"
        cdkDrag
        *ngFor="let childControl of childFormArray.controls; let i = index"
        [formGroupName]="i">
        <div
          class="px-3 pt-6 align-items-center text-center text-color-secondary text-2xl">
          <i
            [pTooltip]="
              childControl.dirty ||
              childControl.get('status')?.value === 'edited' ||
              childControl.get('status')?.value === 'new'
                ? 'Ausprägung wird erst mit dem speichern des Indikators gespeichert.'
                : ''
            "
            class="fas"
            [ngClass]="{
              'fa-check-circle':
                !childControl.dirty &&
                childControl.get('status')?.value === 'check',
              'fa-exclamation-triangle text-orange-500':
                childControl.dirty ||
                childControl.get('status')?.value === 'edited',
              'fa-plus-circle text-green-500':
                childControl.get('status')?.value === 'new',
            }"></i>
        </div>
        <app-form-field-wrapper
          [label]="'Schlüssel'"
          [name]="'key'"
          [formField]="childControl.get('key')"
          [colSize]="3">
          <input pInputText type="text" formControlName="key" class="p-input" />
        </app-form-field-wrapper>

        <app-form-field-wrapper
          [label]="'Name'"
          [name]="'name'"
          [formField]="childControl.get('name')"
          [colSize]="6">
          <input
            pInputText
            type="text"
            formControlName="name"
            class="p-input" />
        </app-form-field-wrapper>

        <app-form-field-wrapper [hideLabel]="true" [colSize]="2">
          <p-button
            class="mr-1"
            (click)="selectChild(childControl.value)"
            icon="fas fa-pen"
            [size]="'small'"
            [rounded]="true"></p-button>
          <p-button
            (click)="removeChild(i)"
            icon="fas fa-trash"
            [severity]="'danger'"
            [size]="'small'"
            [rounded]="true"></p-button>
        </app-form-field-wrapper>
      </div>
    </div>
    <p-divider></p-divider>

    <p-button
      type="button"
      [severity]="'success'"
      [styleClass]="'w-auto'"
      icon="fas fa-circle-plus"
      [rounded]="true"
      [disabled]="!form.value.isSet"
      label="Ausprägung hinzufügen"
      (click)="addChild()"></p-button>
  </div>
  <div class="grid" *ngIf="selectedTab === 'meta'">
    <div class="col-6">
      <app-header
        icon="fas fa-earth-europe"
        text="Öffentliche Informationen"></app-header>
    </div>
    <div class="col-6">
      <app-header
        icon="fas fa-house-user"
        text="Geschützte Informationen"></app-header>
    </div>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Berechnung'"
      [name]="'calculation'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="calculation"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Interner Hinweis'"
      [name]="'hint'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="hint"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Hinweis auf'"
      [name]="'indication'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="indication"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Erhebungszyklus'"
      [name]="'dataCycle'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="dataCycle"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Aussage'"
      [name]="'statement'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="statement"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Ebene der Verfügbarkeit'"
      [name]="'levelOfAvailability'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="levelOfAvailability"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Quelle'"
      [name]="'source'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="source"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Datenlieferant'"
      [name]="'dataSupplier'"
      [floatingLabel]="false"
      [hideLabel]="false">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="dataSupplier"
        [style]="{ height: '100px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>
  </div>
  <ng-container *ngIf="selectedTab === 'legend'">
    <div class="grid align-items-center">
      <ng-container *ngIf="colorsetStore.asArray() as colorsets">
        <app-colorset-dropdown
          [enableNewOption]="true"
          [label]="'Standardfarbset'"
          [name]="'defaultColorSet'"
          [colSize]="8"
          formControlName="defaultColorSet"></app-colorset-dropdown>

        <app-form-field-wrapper
          [colSize]="4"
          [label]="'Farbset invertieren'"
          [name]="'defaultInvert'"
          [floatingLabel]="false"
          [hideLabel]="true">
          <p-checkbox
            class="pt-5"
            inputId="defaultInvert"
            formControlName="defaultInvert"
            [binary]="true"
            label="Farbset invertieren"></p-checkbox>
        </app-form-field-wrapper>
      </ng-container>
    </div>

    <div class="grid">
      <h4 class="col-12"><i class="fas fa-palette"></i> Farben und Klassen</h4>
    </div>

    <div class="grid">
      <app-form-field-wrapper
        [colSize]="5"
        [label]="'Klassenmodus'"
        [name]="'legendMode'">
        <p-dropdown
          (onChange)="legendModeChange($event)"
          id="legendMode"
          formControlName="legendMode"
          [options]="legendModes"
          optionLabel="name"
          optionValue="key"></p-dropdown>
      </app-form-field-wrapper>
    </div>

    @if (form.value.legendMode === 'fixed') {
      <app-legend-form
        [invert]="form.get('defaultInvert')?.value"
        [legendFormArray]="legendFormArray"
        [colorsetId]="form.get('defaultColorSet')?.value"
        [legendData]="form.value.legend">
      </app-legend-form>
    }
  </ng-container>

  <p-divider />

  <app-form-footer
    helpKey="first_doc"
    (cancel)="onCancel()"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkIndicatorRights(itemToEdit.category, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? removeIndicator(itemToEdit) : undefined
    "></app-form-footer>
</form>

<p-sidebar
  (onHide)="onChildOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="childFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="
        store.selectedChild() && store.selectedChild()._id
          ? 'fas fa-file-pen'
          : 'fas fa-file-circle-plus'
      "
      [text]="
        store.selectedChild() && store.selectedChild()._id
          ? 'Ausprägung „' + store.selectedChild().name + '“ erweitern'
          : 'Indikator-Ausprägug anlegen'
      "></app-header
  ></ng-template>

  <ng-container *ngIf="childFormOverlay">
    <router-outlet name="auspraegung"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask
  [visible]="childFormOverlay"
  (click)="onChildOverlayClose()"></app-mask>
